/*
  ODERSO: Bilder und Videos erst laden, wenn man sie braucht.

  1) Bild-Slider in Produktkarten, auf der Produktseite und im Helm-Abschnitt der Startseite:
     Die Bildquellen stehen in data-od-src / data-od-srcset (Liquid, mit "OD:" markiert).
     Bild 1 und 2 (data-od-near) laden etwa 800 px bevor die Karte ins Bild kommt, ab Bild 3 erst,
     sobald man die Karte bzw. den Abschnitt berührt, mit der Maus drüberfährt, per Tastatur
     hineinspringt oder mit den Pfeiltasten blättert. Die Bildbreite (sizes) wird dabei aus der
     echten Größe des Bildfelds berechnet, auch für object-fit: cover.
  2) Zoom-Fenster der Produktseite: Bilder laden erst, wenn das Fenster aufgeht.
  3) Video-Banner (Klasse od-lazy-video): Videos laden und starten erst kurz bevor sie ins Bild kommen
     und pausieren, wenn sie weit weg sind.
*/
(function () {
  "use strict";

  var SEL = "img[data-od-srcset], img[data-od-src]";

  function boxWidth(img) {
    var box = img.closest(".swiper-slide, .product__media, .media") || img.parentElement;
    if (!box) return 0;
    var r = box.getBoundingClientRect();
    var w = r.width;
    var aw = +img.getAttribute("width");
    var ah = +img.getAttribute("height");
    // object-fit: cover braucht bei breiteren Bildern mehr Breite als das Feld
    if (w && r.height && aw && ah) w = Math.max(w, (r.height * aw) / ah);
    return Math.ceil(w);
  }

  function loadImg(img) {
    img.removeAttribute("data-od-near");
    var srcset = img.getAttribute("data-od-srcset");
    var src = img.getAttribute("data-od-src");
    if (!srcset && !src) return;
    if (!img.closest("product-modal")) {
      var w = boxWidth(img);
      if (w > 0) img.sizes = w + "px";
    }
    if (srcset) {
      img.srcset = srcset;
      img.removeAttribute("data-od-srcset");
    }
    if (src) {
      img.src = src;
      img.removeAttribute("data-od-src");
    }
  }

  function loadIn(root) {
    if (!root || !root.querySelectorAll) return;
    var list = root.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) loadImg(list[i]);
  }

  function onIntent(e) {
    var el = e.target;
    if (!el || !el.closest) return;
    // Produktkarte: nur die Bilder dieser Karte
    var card = el.closest(".card-wrapper") || el.closest(".product-card-js");
    if (card) {
      if (card.querySelector(SEL)) loadIn(card);
      return;
    }
    // Produktgalerie (Produktseite, Helm-Abschnitt): alle Bilder der Galerie in diesem Abschnitt
    var sec = el.closest(".shopify-section");
    if (!sec) return;
    var lists = sec.querySelectorAll(".js-media-list");
    for (var i = 0; i < lists.length; i++) {
      if (lists[i].querySelector(SEL)) loadIn(lists[i]);
    }
  }

  ["pointerover", "touchstart", "focusin"].forEach(function (type) {
    document.addEventListener(type, onIntent, { passive: true, capture: true });
  });

  // Pfeiltasten blättern die Galerie auf der Produktseite (eigenes Skript in main-product.liquid)
  document.addEventListener("keydown", function (e) {
    if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
    var lists = document.querySelectorAll(".js-media-list");
    for (var i = 0; i < lists.length; i++) loadIn(lists[i]);
  });

  // Bild 1 und 2 der Karten-Slider und der Helm-Galerie (data-od-near): etwa 800 px bevor sie ins Bild
  // kommen. Swiper entfernt sonst loading="lazy" und alle Karten der Seite laden sofort.
  function loadNear(container) {
    container.__odNearDone = true;
    var imgs = container.querySelectorAll("img[data-od-near]");
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].removeAttribute("data-od-near");
      loadImg(imgs[i]);
    }
  }

  var nearObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              if (!en.isIntersecting) return;
              nearObserver.unobserve(en.target);
              loadNear(en.target);
            });
          },
          { rootMargin: "800px 0px" }
        )
      : null;

  function watchNear(root) {
    var imgs = (root && root.querySelectorAll ? root : document).querySelectorAll("img[data-od-near]");
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var c = img.closest(".product-card-js, .js-media-list, .swiper") || img.parentElement;
      if (c.__odNearDone) {
        // zum Beispiel ein Klon, den Swiper nachträglich anlegt
        img.removeAttribute("data-od-near");
        loadImg(img);
      } else if (!c.__odNear) {
        c.__odNear = true;
        if (nearObserver) nearObserver.observe(c);
        else loadNear(c);
      }
    }
  }

  // neue Karten (Passt dazu, Nachladen in Kategorien, Swiper-Klone) ebenfalls beobachten
  if ("MutationObserver" in window) {
    new MutationObserver(function (records) {
      for (var r = 0; r < records.length; r++) {
        var added = records[r].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches("img[data-od-near]")) || (node.querySelector && node.querySelector("img[data-od-near]"))) {
            watchNear(node.parentElement || node);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Zoom-Fenster: Bilder laden, sobald es aufgeht
  function watchModals() {
    var modals = document.querySelectorAll("product-modal");
    for (var i = 0; i < modals.length; i++) {
      var m = modals[i];
      if (m.__odWatched) continue;
      m.__odWatched = true;
      if (m.hasAttribute("open")) loadIn(m);
      new MutationObserver(function (records) {
        records.forEach(function (rec) {
          if (rec.target.hasAttribute("open")) loadIn(rec.target);
        });
      }).observe(m, { attributes: true, attributeFilter: ["open"] });
    }
  }

  // Videos erst in der Nähe des Bildschirms laden und abspielen
  var videoObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              var v = en.target;
              if (en.isIntersecting) {
                if (!v.__odStarted) {
                  v.__odStarted = true;
                  v.preload = "auto";
                  v.autoplay = true;
                }
                var p = v.play();
                if (p && p.catch) p.catch(function () {});
              } else if (v.__odStarted && !v.paused) {
                v.pause();
              }
            });
          },
          { rootMargin: "600px 0px" }
        )
      : null;

  function watchVideos() {
    var vids = document.querySelectorAll("video.od-lazy-video");
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (v.__odObserved) continue;
      v.__odObserved = true;
      if (videoObserver) {
        videoObserver.observe(v);
      } else {
        v.preload = "auto";
        v.autoplay = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
  }

  function init() {
    watchNear(document);
    watchModals();
    watchVideos();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  window.addEventListener("load", watchModals);
  document.addEventListener("shopify:section:load", function (e) {
    init();
    loadIn(e.target);
  });
})();

/*
  OD: JingleBe-Seite (/pages/jinglebe): Play-Buttons wie auf der alten jinglebe.com.
  Es spielt immer nur ein Jingle. Nochmal tippen pausiert, ein anderer Jingle stoppt den laufenden.
  Die MP3 lädt erst beim Abspielen (data-audio am Listeneintrag), darunter läuft ein dünner Fortschrittsbalken.
*/
(function () {
  "use strict";

  var audio = null;
  var current = null;

  function bar(item) {
    var meta = item.querySelector(".od-jb-meta");
    if (!meta) return null;
    var b = meta.querySelector(".od-jb-progress");
    if (!b) {
      b = document.createElement("span");
      b.className = "od-jb-progress";
      b.setAttribute("aria-hidden", "true");
      b.appendChild(document.createElement("i"));
      meta.appendChild(b);
    }
    return b.firstChild;
  }

  function mark(item, playing) {
    item.classList.toggle("is-playing", playing);
    var btn = item.querySelector(".od-jb-play");
    if (!btn) return;
    var title = (item.querySelector(".od-jb-title") || {}).textContent || "Jingle";
    btn.setAttribute("aria-pressed", playing ? "true" : "false");
    btn.setAttribute("aria-label", title + (playing ? " pausieren" : " abspielen"));
  }

  function player() {
    if (audio) return audio;
    audio = new Audio();
    audio.preload = "none";
    audio.addEventListener("timeupdate", function () {
      if (!current || !audio.duration) return;
      var i = bar(current);
      if (i) i.style.width = (100 * audio.currentTime) / audio.duration + "%";
    });
    audio.addEventListener("ended", function () {
      if (!current) return;
      mark(current, false);
      var i = bar(current);
      if (i) i.style.width = "0";
    });
    audio.addEventListener("pause", function () {
      if (current) mark(current, false);
    });
    audio.addEventListener("play", function () {
      if (current) mark(current, true);
    });
    return audio;
  }

  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(".od-jb-play") : null;
    if (!btn) return;
    var item = btn.closest(".od-jb-item");
    var src = item && item.getAttribute("data-audio");
    if (!src) return;
    e.preventDefault();
    var a = player();
    if (item === current) {
      if (a.paused) a.play().catch(function () {});
      else a.pause();
      return;
    }
    if (current) {
      a.pause();
      mark(current, false);
      var old = bar(current);
      if (old) old.style.width = "0";
    }
    current = item;
    a.src = src;
    mark(item, true);
    a.play().catch(function () {
      mark(item, false);
    });
  });
})();
